/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const AdminReferences32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 7.692v16.616c0 2.675.278 3.645.801 4.622A5.452 5.452 0 003.07 31.2c.978.522 1.948.801 4.623.801h16.616c2.675 0 3.645-.279 4.622-.801a5.452 5.452 0 002.269-2.27c.522-.977.801-1.947.801-4.622V7.692c0-2.675-.279-3.645-.801-4.623A5.452 5.452 0 0028.93.801C27.953.278 26.983 0 24.308 0H7.692C5.017 0 4.047.278 3.069.801A5.452 5.452 0 00.801 3.07C.278 4.047 0 5.017 0 7.692z"
            fill={vars.bdlGray80}
        />
        <path
            d="M16.255 14.529A3.37 3.37 0 0114.5 15a3.387 3.387 0 01-1.764-.471 3.552 3.552 0 01-1.264-1.273A3.453 3.453 0 0111 11.471c-.006-.64.15-1.221.467-1.744a3.621 3.621 0 011.274-1.256A3.394 3.394 0 0114.501 8a3.4 3.4 0 011.749.467c.532.312.957.729 1.274 1.252.317.523.476 1.104.476 1.744 0 .661-.159 1.26-.476 1.793a3.59 3.59 0 01-1.27 1.273zM15.005 17c.94 0 1.81.106 2.612.318A4.987 4.987 0 0016 21c0 1.126.372 2.164 1 3H9.198c-.822 0-1.394-.125-1.716-.374-.321-.25-.482-.598-.482-1.045 0-.597.187-1.217.562-1.862.374-.645.911-1.25 1.61-1.813.7-.564 1.542-1.023 2.527-1.376.984-.353 2.086-.53 3.306-.53zm6.918 2.964a.157.157 0 00-.154.16v1.285c0 .088.07.16.154.16a.157.157 0 00.154-.16v-1.285a.157.157 0 00-.154-.16z"
            fill="#fff"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 25a4 4 0 100-8 4 4 0 000 8zm2-5.456L21 18.5l-2 1.044v1.223c0 1.132.947 2.479 1.965 2.725L21 23.5l.035-.008C22.053 23.246 23 21.899 23 20.767v-1.223z"
            fill="#fff"
        />
    </AccessibleSVG>
);

export default AdminReferences32;
